import { Outlet } from "react-router-dom";

const LinksParentPage = () => {
    return (
        <Outlet />
    );
};

export default LinksParentPage;
